import { render, staticRenderFns } from "./bridgeLog.vue?vue&type=template&id=2b6c1776&scoped=true"
import script from "./bridgeLog.vue?vue&type=script&lang=js"
export * from "./bridgeLog.vue?vue&type=script&lang=js"
import style0 from "./bridgeLog.vue?vue&type=style&index=0&id=2b6c1776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c1776",
  null
  
)

export default component.exports